import { render } from "./ManageVolumes.vue?vue&type=template&id=7e609717&scoped=true"
import script from "./ManageVolumes.vue?vue&type=script&lang=js"
export * from "./ManageVolumes.vue?vue&type=script&lang=js"

import "./ManageVolumes.vue?vue&type=style&index=0&id=7e609717&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e609717"]])

export default __exports__